import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { AxiosProps } from '../../interfaces';
import { getStoredToken } from '../../utils/auth';

axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  // An explicit header (ApiKey, third-party token) always wins.
  if (config.headers.get('Authorization')) return config;

  // No usable token means no header at all: the API then treats the request
  // as unauthenticated (401, or an error envelope on the intelligence host),
  // while `Bearer undefined` is a malformed token (400 IDX12709) that bypasses
  // the normal unauthenticated handling (DEV-1150).
  const token = getStoredToken();
  // eslint-disable-next-line no-param-reassign
  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
});

axios.interceptors.response.use(response => {
  if (response?.data?.Errors) {
    const errorMessage =
      response?.data?.Errors?.data_error?.errors[0] ||
      'Something went wrong, please try again later';
    throw new AxiosError(errorMessage, '400', undefined, undefined, {
      ...response,
      data: errorMessage
    });
  }

  return response;
});

export async function axiosHelper({
  endpoint,
  method,
  params,
  baseURL = process.env.API_BASE_URL,
  body,
  ...rest
}: AxiosProps) {
  if (endpoint.includes('undefined'))
    // eslint-disable-next-line no-param-reassign
    endpoint = endpoint.replace('undefined', '');

  return axios(endpoint, {
    method,
    data: body,
    params,
    baseURL,
    ...rest
  }).then(response => response.data);
}
